import { getAllFilesFrontMatter } from "@/utils/blog/mdx";
import siteMetadata from "@/data/siteMetadata";
import ListLayout from "@/components/blog/layout/ListLayout";
import PageInfo from "@/components/PageInfo";
import Navbar from "@/components/Navbar";
import { POSTS_PER_PAGE } from "../index";
import { Container } from "@chakra-ui/react";
import Footer from "@/components/Footer";
import Head from "next/head";

export async function getStaticPaths() {
  const totalPosts = await getAllFilesFrontMatter("blog");
  const totalPages = Math.ceil(totalPosts.length / POSTS_PER_PAGE);
  const paths = Array.from({ length: totalPages }, (_, i) => ({
    params: { page: (i + 1).toString() },
  }));

  return {
    paths,
    fallback: false,
  };
}

export async function getStaticProps(context) {
  const {
    params: { page },
  } = context;
  const posts = await getAllFilesFrontMatter("blog");
  const pageNumber = parseInt(page);
  const initialDisplayPosts = posts.slice(
    POSTS_PER_PAGE * (pageNumber - 1),
    POSTS_PER_PAGE * pageNumber,
  );
  const pagination = {
    currentPage: pageNumber,
    totalPages: Math.ceil(posts.length / POSTS_PER_PAGE),
  };

  return {
    props: {
      posts,
      initialDisplayPosts,
      pagination,
    },
  };
}

export default function PostPage({ posts, initialDisplayPosts, pagination }) {
  return (
    <>
      <PageInfo title="Blog" description={siteMetadata.description} />
      <Head>
        {/* canonical */}
        <link rel="canonical" href={process.env.NEXT_PUBLIC_DOMAIN_SHARE + "/blog"} />
      </Head>
      <Navbar />
      <Container>
        <ListLayout
          title="Our Blog"
          posts={posts}
          initialDisplayPosts={initialDisplayPosts}
          pagination={pagination}
        />
      </Container>
      <Footer />
    </>
  );
}
